import type { IBlogListItem } from '../../../models/blog-list-item.model';

export default class BlogListItemApiModel {
  public pictureHtml!: string;
  public imageAltText!: string;
  public url!: string;
  public heading!: string;
  public text!: string;

  public static mapToBusinessModel(apiModel: BlogListItemApiModel): IBlogListItem {
    return {
      pictureHtml: apiModel.pictureHtml,
      imageAltText: apiModel.imageAltText,
      url: apiModel.url,
      heading: apiModel.heading,
      text: apiModel.text,
    };
  }
}
